import React, { FC } from 'react';
import cls from 'classnames';
import { ChipActionProps } from './ChipAction.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
import { ColorClassnames } from '@stashinvest/tailwind/src/theme';
import LoaderIndeterminateCircular from '../../loader/loaderIndeterminateCircular';

export const classNames = getClassNames('sds-chip-action', [
	'field',
	'is-selected',
	'is-loading',
	'variant-secondary',
]);
const mapVariantToIconColor: Record<string, ColorClassnames> = {
	outline: 'text-primary',
	secondary: 'text-onSurface',
};

const ChipAction: FC<ChipActionProps> = (props) => {
	const {
		className,
		text,
		variant = 'outline',
		isDisabled = false,
		isLoading = false,
		isSelected = false,
		onClick,
		Icon,
		label,
	} = props;

	return (
		<button
			disabled={isDisabled}
			className={cls(
				getRootClassListFromProps(classNames, props),
				`variant-${variant}`,
				className
			)}
			data-testid={props['data-testid']}
			onClick = {onClick}
			aria-label={label}
		>
			{isLoading ? (
				<LoaderIndeterminateCircular
					size="small"
					fill={variant === 'secondary' ? 'onSurfaceVariant' : 'primary'}
				/>
			) : (
				<>{Icon && <Icon size="2XS" color={isDisabled ? undefined : mapVariantToIconColor[variant]} />}</>
			)}
			<span>{text}</span>
		</button>
	);
};

ChipAction.displayName = 'ChipAction';

export default ChipAction;
